export default {"src":"/_next/static/media/vegetable.3358df1b.svg","height":200,"width":200,"blurWidth":0,"blurHeight":0};